import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { MarketingLayout, Section, Overline } from "@/marketing/MarketingLayout";
import { SUCCESS, PLAN } from "@/marketing/content";
import { ArrowRight, MapPin, Clock, GraduationCap } from "lucide-react";

export default function MarketingSuccess() {
  const navigate = useNavigate();
  return (
    <MarketingLayout>
      <Section className="pt-16 pb-4">
        <Overline>{SUCCESS.hero.eyebrow}</Overline>
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tighter mb-5 max-w-3xl">{SUCCESS.hero.heading}</h1>
        <p className="text-lg text-muted-foreground max-w-2xl">{SUCCESS.hero.subheading}</p>
      </Section>

      <Section className="pt-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {SUCCESS.stats.map((s) => (
            <div key={s.label} className="p-6 rounded-md border border-border bg-card" data-testid="success-stat">
              <div className="font-mono text-3xl font-black text-primary">{s.value}</div>
              <div className="text-sm text-muted-foreground mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </Section>

      <Section className="pt-12">
        <div className="grid md:grid-cols-2 gap-4">
          {SUCCESS.stories.map((s) => (
            <div
              key={s.name}
              className={`p-6 rounded-md border bg-card ${s.highlight ? "border-primary/50 md:col-span-2" : "border-border"}`}
              data-testid="success-story"
            >
              <div className="flex items-start justify-between gap-4 mb-3">
                <div>
                  <h3 className="font-heading font-bold text-lg">{s.name}</h3>
                  <p className="text-sm text-muted-foreground">{s.role} · {s.company}</p>
                </div>
                <span className="font-mono text-sm text-success font-bold shrink-0">{s.package}</span>
              </div>
              <p className="text-sm leading-relaxed mb-4">"{s.quote}"</p>
              <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground font-mono">
                <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" /> {s.location}</span>
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {s.daysToOffer} days to offer</span>
                <span className="flex items-center gap-1"><GraduationCap className="w-3.5 h-3.5" /> {s.degree}</span>
              </div>
            </div>
          ))}
        </div>
      </Section>

      <Section className="pt-16">
        <div className="rounded-md bg-primary text-primary-foreground p-10 text-center">
          <h2 className="font-heading text-3xl font-black tracking-tight mb-3">Your Success Story Starts Here</h2>
          <p className="opacity-90 max-w-2xl mx-auto mb-7">Join thousands of freshers who trusted EliteHire India to launch their careers.</p>
          <Button size="lg" variant="secondary" onClick={() => navigate("/register")} className="rounded-md gap-2 h-12 px-6" data-testid="success-cta">
            {PLAN.cta} <ArrowRight className="w-4 h-4" />
          </Button>
        </div>
      </Section>
    </MarketingLayout>
  );
}
